import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'input[noSpaces]'
})
export class NoSpacesDirective {

    constructor(private _el: ElementRef) { }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/\s\s/, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }

}

